
import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class SectionEditPlaceholder extends Vue {}
